import React from "react";

// Team members data
const teamMembers = [
  {
    id: 1,
    name: "Dr. Shafiq Chaudary",
    title: "Chairman and Board of Director",
    image: require("../../../assets/shafik.jpeg"),
    linkedin: "https://www.linkedin.com/in/umar-rasheed/",
  },
  {
    id: 2,
    name: "Muhammad Ahmad",
    title: "CEO and Cofounder",
    image: require("../../../assets/mahmad.jpeg"),
    linkedin: "https://www.linkedin.com/in/muhammad-ahmad-935075222?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 3,
    name: "Umar Rasheed",
    title: "CTO and Cofounder",
    image: require("../../../assets/umar-bhai.jpg"),
    linkedin: "https://www.linkedin.com/in/umar-rasheed/",
  },
  {
    id: 4,
    name: "Faizan Afzal",
    title: "Lead FullStack Engineer",
    image: require("../../../assets/faizan.jpeg"),
    linkedin: "https://www.linkedin.com/in/faizanafzal54/",
  },
   {
    id: 5,
    name: "Attiqa",
    title: "Creative Design Lead (UI/UX)",
    image: require("../../../assets/Attiqa.jpg"),
  },
  {
    id: 6,
    name: "Abdullah Chaudhry",
    title: "Sales & Marketing",
    image: require("../../../assets/abdullah.jpeg"),
    linkedin: "https://pk.linkedin.com/in/abdullah-chaudhry-861b74232",
  },
  {
    id: 7,
    name: "Muhammad Abdullah",
    title: "Lead Software Quality Assurance",
    image: require("../../../assets/Abdullah bahi.jpeg"),
    linkedin: "https://www.linkedin.com/in/faizanafzal54/",
  },
  
  { id: 8,
    name: "Jamal Hajvary",
    title: "Lead Business Developer",
    image: require("../../../assets/Jamal_lead_Business_developer.png"),
    linkedin: "https://www.linkedin.com/in/faizanafzal54/",
  },
  {
    id: 9,
    name: "Zain Ali ",
    title: "Senior Software Engineer",
    image: require("../../../assets/zain.jpg"),
    linkedin: "https://www.linkedin.com/in/zain-ali-17b988361?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    id: 10,
    name: "Usama Naseer",
    title: "Senior Software Engineer",
    image: require("../../../assets/usama.jpeg"),
    linkedin: "https://www.linkedin.com/in/faizanafzal54/",
  },
   {
    id: 11,
    name: "Umer Farooq",
    title: "Senior Software Engineer",
    image: require("../../../assets/UmerFarooq.jpg"),
   
  },
  {
    id: 12,
    name: "Muhammad Awais",
    title: "Shopify Engineer",
    image: require("../../../assets/Awais.jpg"),
    linkedin: "http://www.linkedin.com/in/awais-butt-504467343",
  },
  {
    id: 13,
    name: "Shahbaz Aslam",
    title: "Associate Software Engineer",
    image: require("../../../assets/shahbaz.jpg"),
    linkedin: "http://www.linkedin.com/in/zunnurain-builders-ba6aa7343",
  },
  {
    id: 14,
    name: "Suhaib",
    title: "Junior Software Engineer",
    image: require("../../../assets/suhab.jpg"),
    linkedin: "http://www.linkedin.com/in/suhaib-with-code-10964632a",
  },
];

const TeamSection = () => {
  const handleProfileClick = (linkedin) => {
    window.open(linkedin, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="mt-20 py-16 px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
      <h1 className="text-4xl md:text-5xl font-bold text-center mb-6 font-primary">Meet our team</h1>

      <div className="text-center mb-12 max-w-3xl mx-auto">
        <p className="text-lg font-primary">
          We <span className="font-semibold font-primary">care</span> about our clients, employees and community; we serve them with
          our extreme <span className="font-semibold font-primary">drive</span>, high{" "}
          <span className="font-semibold font-primary">integrity</span> and reliable <span className="font-semibold font-primary">teamwork</span>;
          and we strive for <span className="font-semibold">excellence</span> in all we do.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        {teamMembers.map((member) => (
          <div key={member.id} className="flex flex-col items-center">
            <div
              className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden cursor-pointer transition-transform hover:scale-105"
            // onClick={() => handleProfileClick(member.linkedin)}
            >
              <img
                src={member.image.default || member.image || "/placeholder.svg"}
                alt={member.name}
                width={240}
                height={240}
                className="w-full h-full object-cover grayscale"
              />
            </div>
            <h3 className="mt-4 text-xl font-semibold text-center font-primary">{member.name}</h3>
            <p className="text-center text-gray-700 font-primary">{member.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
